import { Config } from "./configTypes";

export const buildInternationalConfig = async (): Promise<Config> => {
  // Config
  const isLocalhost =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1");
  const configs = {
    baseUrl:
      (isLocalhost
        ? process.env.REACT_APP_INT_API_URL
        : (window as any)?.env?.baseUrl) || process.env.REACT_APP_INT_API_URL,
    depositUrl:
      (window as any)?.env?.depositUrl || process.env.REACT_APP_DEPOSIT_URL,
  };

  return {
    siteTitle: "Trive International Partners",
    whatsappUrl: process.env.REACT_APP_WHATSAPP_NUMBER,

    company: {
      COMPANY_ID: Number(process.env.REACT_APP_INT_COMPANY_ID) || 0,
      SUPPORT_EMAIL: process.env.REACT_APP_INT_SUPPORT_EMAIL || "",
      FAQ_URL: process.env.REACT_APP_FAQ_REDIRECT_URL || "",
    },

    api: {
      API_URL: configs.baseUrl,
      DEPOSIT_URL: configs.depositUrl,
    },
  };
};
